import React from 'react';
import { NavLink } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

const ApplicationDraft = () => {
	const navigate = useNavigate();
	const status = sessionStorage.getItem('status') || 'draft';
	console.log('Application status:', status);

	const handleBackToHome = () => {
		// Clear all necessary items from sessionStorage
		sessionStorage.removeItem('token');
		sessionStorage.removeItem('applicationId');
		sessionStorage.removeItem('name');
		sessionStorage.removeItem('status');
		// Redirect to signin page
		navigate('/login');
	};

	const handleContinue = () => {
		// Use full reload to ensure sessionStorage is checked
       console.log('Continuing to form...');
		window.location.href = '/form';
	};

	return (
		<>
			<div className="container container_cust">
				<div className="application_minh">
					{status === 'Draft' ? (
						<div className="application_bg">
							<img src="/assets/images/checkgreen.svg" className="img_check_draft" alt="" />
							<h3>Application in Draft</h3>
							<p>Your application is saved as a draft.</p>
							<p>Please continue editing to move forward and complete your application submission.</p>
							<ul className="editbutton_list">
								<li>
									<button className="continue_btn" onClick={handleContinue}>
										<img src="/assets/images/edit.svg" alt="" />
										Continue Editing
									</button>
								</li>
								<li>
									<NavLink onClick={handleBackToHome} to="#" className="backhome">
										back to home
									</NavLink>
								</li>
							</ul>
						</div>
					) : status === 'undefined' ? (
						(window.location.href = '/form')
					) : status === 'Submitted' ? (
						<div className="application_bg">
							<img src="/assets/images/checkgreen.svg" className="img_check_draft" alt="" />
							<h3>Application Under Review</h3>
							<p>Your application is currently under review.</p>
							<p>Please check this page regularly for further updates.</p>
							<ul className="editbutton_list">
								{/* <li>
                                <button className="continue_btn" onClick={handleContinue}>
                                    <img src="/assets/images/image_74" alt="" />
                                    BACK TO HOME
                                </button>
                            </li> */}
								<li>
									<NavLink onClick={handleBackToHome} to="#" className="backhome">
										back to home
									</NavLink>
								</li>
							</ul>
						</div>
					) : status === 'Accepted' ? (
						<div className="application_bg">
							<img src="/assets/images/congrats.svg" className="img_check_draft" alt="" />
							<h3>Congratulations</h3>
							<p> Your application has been accepted. Please proceed with the next steps.</p>
							<ul className="editbutton_list">
								{/* <li>
                                <button className="continue_btn" onClick={handleContinue}>
                                    <img src="/assets/images/image_74" alt="" />
                                    BACK TO HOME
                                </button>
                            </li> */}
								<li>
									<NavLink href="/login" className="backhome">
										Submit Annexure A and Annexure B
									</NavLink>
								</li>
							</ul>
						</div>
					) : status === 'Rejected' ? (
						<div className="application_bg">
							<img src="/assets/images/congrats.svg" className="img_check_draft" alt="" />
							<h3>Congratulations</h3>
							<p> Your application has been accepted. Please proceed with the next steps.</p>
							<ul className="editbutton_list">
								{/* <li>
                                <button className="continue_btn" onClick={handleContinue}>
                                    <img src="/assets/images/image_74" alt="" />
                                    BACK TO HOME
                                </button>
                            </li> */}
								<li>
									<NavLink to="/login" className="backhome">
										Submit Annexure A and Annexure B
									</NavLink>
								</li>
							</ul>
						</div>
					) : (
						<div className="application_bg">
							<img src="/assets/images/reject.svg" className="img_check_draft" alt="" />
							<h3>Application Not Selected</h3>
							<p> We regret to inform you that your application was not selected this time. Thank you for applying.</p>
							<ul className="editbutton_list">
								{/* <li>
                                <button className="continue_btn" onClick={handleContinue}>
                                    <img src="/assets/images/image_74" alt="" />
                                    BACK TO HOME
                                </button>
                            </li> */}
								<li>
									<NavLink onClick={handleBackToHome} to="#" className="backhome">
										back to home
									</NavLink>
								</li>
							</ul>
						</div>
					)}
				</div>
			</div>
		</>
	);
};

export default ApplicationDraft;
